var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"max-h-screen relative"},[(_vm.showDashboardHeader)?_c('dashboard-header'):_c('brand-header',{attrs:{"back-icon":"","light-background":"","back-route":{ name: _vm.ClientRouteName.REPORTS }}}),_c('main',{staticClass:"bg-gray-lighter overflow-auto h-screen sm:px-10 pb-10 mt-5",style:({
        paddingTop: (_vm.offset + "px"),
      })},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }